import { render, staticRenderFns } from "./SavingItem.vue?vue&type=template&id=3837e0f2&scoped=true&"
import script from "./SavingItem.vue?vue&type=script&lang=js&"
export * from "./SavingItem.vue?vue&type=script&lang=js&"
import style0 from "./SavingItem.vue?vue&type=style&index=0&id=3837e0f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837e0f2",
  null
  
)

export default component.exports